module.exports = __webpack_public_path__ + "2-53.jpg?82085b38834749f26356eb4c78df63e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-53.jpg
// module id = 130
// module chunks = 0